export const FEATURE_FLAGS = [
  {
    name: "new-tender-2",
    local: "control", // control, variant1, variant2
  },
  {
    name: "enable-email-send",
    local: true,
  },
  {
    name: "enable-geolocation",
    local: "test",
  },
  {
    name: "car-mechanic-specify-photo-subheader",
    local: "test", // test or control
  },
  {
    name: "hide-deadline",
    local: "test", // test or control
  },
];
